import { ExtractProps, withTranslations } from 'hooks/useTranslations'
import { graphql, useStaticQuery } from 'gatsby'
declare global {
  interface Snippets {
    'templates-PDP': {
      only_for_b2b_available: void
      only_for_b2c_available: void
      change_customer_group: void
      to_measure_item_available: void
      b2b: void
      b2c: void
      channel_status: {
        STATUS: string
        customer: string
      }
      go_on_as_b2b: void
      go_on_as_b2c: void
      only_for_b2b: void
      only_for_b2c: void
      per_piece_text: void
      piece_price: void
      squaremeter_price: void
      add_to_cart_btn: void
      sold_out_btn: void
      customizable_btn: void
      color_label: void
      size_label: void
      variant_label: void
      style_label: void
      color_label_number: {
        pieces: string
      }
      size_label_number: {
        pieces: string
      }
      variant_label_number: {
        pieces: string
      }
      style_label_number: {
        pieces: string
      }
      filter_apply_btn: void
      price_range_from: void
      pdp_article_number_text: void
      pdp_article_has_specimen_text: void
      product_informations: void
      downloads: void
      productSlider_related_to: {
        productName: string
      }
      surcharge_brink: void
      series_link: {
        seriesName: string
      }
      oneToOneBundle_table_column: string
      oneToOneBundle_table_top: string
      please_customize: void
      square: void
      round: void
      oval: void
      rectangular: void
      shape_label: void
      brink_label: void
      brink_width_label: void
      please_choose_option: void
      width_label: void
      length_label: void
      width_info: { width: string; unit: string }
      length_info: { length: string; unit: string }
      desired_size: void
      normal_brink_type: void
      mitred_brink_type: void
      width_unit_info: { unit: string }
      length_unit_info: { unit: string }
      min_max_info: { min_width: string; max_width: string; unit: string }
      surcharge: void
      deliverable: void
      soon_deliverable: void
      non_deliverable: void
      product_info_link: void
      modal_intro_headline: void
      modal_step_1: { ACTIVATE_3D_VIEW: string }
      modal_step_2: { VIEW_IN_AR: string }
      modal_step_3: { GOOD_LIGHTING: string }
      modal_step_4: { ENOUGH_DISTANCE: string }
      modal_step_5: { EVEN_SURFACE: string }
      modal_now_in_3d: void
      modal_open_3d: void
      open_3d_view: void
      gallery_lightbox_zoom: void
      gallery_lightbox_indicator: {
        current: string
        total: string
      }
      meta_title: {
        productName: string
        brand: string
        attribut: string
      }
      meta_description: {
        productName: string
        brand: string
        attribut: string
      }
      rating_amount_text: { COUNT: string }
      ratings_headline: void
      size_chart_link: string
      templates_PDP_buy_box_buywrapper_a11y_decrease_amount_button: void
      templates_PDP_buy_box_buywrapper_a11y_amount_input: void
      templates_PDP_buy_box_buywrapper_a11y_increase_amount_button: void
      templates_PDP_filterdrawer_customtailor_a11y_decrease_width_button: void
      templates_PDP_filterdrawer_customtailor_a11y_width_amount_input: void
      templates_PDP_filterdrawer_customtailor_a11y_increase_width_button: void
      templates_PDP_filterdrawer_customtailor_a11y_decrease_length_button: void
      templates_PDP_filterdrawer_customtailor_a11y_length_amount_input: void
      templates_PDP_filterdrawer_customtailor_a11y_increase_length_button: void
      sizeChart_product_size_table_title: void
      sizeChart_international_size_table_title: void
      sizeChart_clothing_size: void
      sizeChart_button_label: void
      sizeChart_arm_length_info: void
      sizeChart_back_length_info: void
      sizeChart_chest_measurement_info: void
      sizeChart_hip_measurement_info: void
      sizeChart_inner_leg_length_info: void
      sizeChart_total_length_info: void
      sizeChart_waist_measurement_info: void
      sizeChart_waist_size_info: void
      sizeChart_measurement_infobox_title: void
      sizeChart_measurement_infobox_text1: void
      sizeChart_measurement_infobox_text2: void
      sizeChart_measurement_tutorial_image_alt: void
      sizeChart_scrollable_label: void
      redirect_to_product: void
      per_squaremeter_text: void
      pdp_successor_product: void
      pdp_alternative_product: void
      pdp_alternative_products: void
      manufacturer_info: void
      manufacturer_name: void
      manufacturer_address: void
      manufacturer_mail: void
      gallery_lightbox_previous: void
      gallery_lightbox_next: void
      thumbnail_bar_previous: void
      thumbnail_bar_next: void
      highlight_product_action_btn_label: string
      to_filter_drawer_title: void
      BFSG_add_to_wishlist_button: void
      BFSG_remove_from_wishlist_button: void
      BFSG_share_button: void
      BFSG_color_filter_option: {
        color: string
      }
      BFSG_open_gallery_fullscreen: void
      BFSG_select_gallery_thumbnail: {
        index: number
      }
      BFSG_select_gallery_thumbnail_video: void
      BFSG_open_3d_view: void
      BFSG_filterdrawer_close: void
      BFSG_filterdrawer_apply: void
      BFSG_filterdrawer_option: {
        filterKey: string
        filterOption: string
      }
      BFSG_sizechart_button: void
      BFSG_filterdrawer_customtailor_brink_filter: {
        option: string
      }
      BFSG_filterdrawer_customtailor_brinkwidth_filter: {
        option: string
      }
      BFSG_filterdrawer_customtailor_shape_filter: {
        option: string
      }
      BFSG_show_more_options: void
      BFSG_close_size_table_modal: void
    }
    stockInfo: {
      available_stock: {
        stock: number
      }
    }
  }
}

export default <C extends React.FC<ExtractProps<C>>>(Component: C) => {
  return withTranslations(Component, () =>
    useStaticQuery(graphql`
      query templates_PDP_translations {
        per_piece_text: snippet(group: "templates-PDP", name: "per_piece_text")
        piece_price: snippet(group: "templates-PDP", name: "piece_price")
        b2b: snippet(group: "templates-PDP", name: "b2b")
        b2c: snippet(group: "templates-PDP", name: "b2c")
        squaremeter_price: snippet(
          group: "templates-PDP"
          name: "squaremeter_price"
        )
        only_for_b2b_available: snippet(
          group: "templates-PDP"
          name: "only_for_b2b_available"
        )
        only_for_b2c_available: snippet(
          group: "templates-PDP"
          name: "only_for_b2c_available"
        )
        change_customer_group: snippet(
          group: "templates-PDP"
          name: "change_customer_group"
        )
        channel_status: snippet(group: "templates-PDP", name: "channel_status")
        go_on_as_b2b: snippet(group: "templates-PDP", name: "go_on_as_b2b")
        go_on_as_b2c: snippet(group: "templates-PDP", name: "go_on_as_b2c")
        only_for_b2b: snippet(group: "templates-PDP", name: "only_for_b2b")
        only_for_b2c: snippet(group: "templates-PDP", name: "only_for_b2c")
        surcharge_brink: snippet(
          group: "templates-PDP"
          name: "surcharge_brink"
        )
        product_info_link: snippet(
          group: "templates-PDP"
          name: "product_info_link"
        )
        pdp_article_has_specimen_text: snippet(
          group: "templates-PDP"
          name: "pdp_article_has_specimen_text"
        )
        add_to_cart_btn: snippet(
          group: "templates-PDP"
          name: "add_to_cart_btn"
        )
        sold_out_btn: snippet(group: "templates-PDP", name: "sold_out_btn")
        customizable_btn: snippet(
          group: "templates-PDP"
          name: "customizable_btn"
        )
        product_informations: snippet(
          group: "templates-PDP"
          name: "product_informations"
        )
        downloads: snippet(group: "templates-PDP", name: "downloads")
        productSlider_related_to: snippet(
          group: "templates-PDP"
          name: "productSlider_related_to"
        )
        color_label: snippet(group: "templates-PDP", name: "color_label")
        color_label_number: snippet(
          group: "templates-PDP"
          name: "color_label_number"
        )
        variant_label: snippet(group: "templates-PDP", name: "variant_label")
        size_label: snippet(group: "templates-PDP", name: "size_label")
        style_label: snippet(group: "templates-PDP", name: "style_label")
        variant_label_number: snippet(
          group: "templates-PDP"
          name: "variant_label_number"
        )
        size_label_number: snippet(
          group: "templates-PDP"
          name: "size_label_number"
        )
        style_label_number: snippet(
          group: "templates-PDP"
          name: "style_label_number"
        )
        series_link: snippet(group: "templates-PDP", name: "series_link")

        price_range_from: snippet(
          group: "templates-PDP"
          name: "price_range_from"
        )
        filter_apply_btn: snippet(
          group: "templates-PDP"
          name: "filter_apply_btn"
        )
        pdp_article_number_text: snippet(
          group: "templates-PDP"
          name: "pdp_article_number_text"
        )
        oneToOneBundle_table_column: snippet(
          group: "templates-PDP"
          name: "oneToOneBundle_table_column"
        )
        oneToOneBundle_table_top: snippet(
          group: "templates-PDP"
          name: "oneToOneBundle_table_top"
        )
        available_stock: snippet(group: "stockInfo", name: "available_stock")
        please_customize: snippet(
          group: "templates-PDP"
          name: "please_customize"
        )
        square: snippet(group: "templates-PDP", name: "square")
        round: snippet(group: "templates-PDP", name: "round")
        oval: snippet(group: "templates-PDP", name: "oval")
        rectangular: snippet(group: "templates-PDP", name: "rectangular")
        shape_label: snippet(group: "templates-PDP", name: "shape_label")
        brink_label: snippet(group: "templates-PDP", name: "brink_label")
        brink_width_label: snippet(
          group: "templates-PDP"
          name: "brink_width_label"
        )
        please_choose_option: snippet(
          group: "templates-PDP"
          name: "please_choose_option"
        )
        width_label: snippet(group: "templates-PDP", name: "width_label")
        length_label: snippet(group: "templates-PDP", name: "length_label")
        width_info: snippet(group: "templates-PDP", name: "width_info")
        length_info: snippet(group: "templates-PDP", name: "length_info")
        desired_size: snippet(group: "templates-PDP", name: "desired_size")
        normal_brink_type: snippet(
          group: "templates-PDP"
          name: "normal_brink_type"
        )
        mitred_brink_type: snippet(
          group: "templates-PDP"
          name: "mitred_brink_type"
        )
        width_unit_info: snippet(
          group: "templates-PDP"
          name: "width_unit_info"
        )
        length_unit_info: snippet(
          group: "templates-PDP"
          name: "length_unit_info"
        )
        surcharge: snippet(group: "templates-PDP", name: "surcharge")
        min_max_info: snippet(group: "templates-PDP", name: "min_max_info")
        deliverable: snippet(group: "templates-PDP", name: "deliverable")
        soon_deliverable: snippet(
          group: "templates-PDP"
          name: "soon_deliverable"
        )
        non_deliverable: snippet(
          group: "templates-PDP"
          name: "non_deliverable"
        )
        modal_intro_headline: snippet(
          group: "templates-PDP"
          name: "modal_intro_headline"
        )
        modal_step_1: snippet(group: "templates-PDP", name: "modal_step_1")
        modal_step_2: snippet(group: "templates-PDP", name: "modal_step_2")
        modal_step_3: snippet(group: "templates-PDP", name: "modal_step_3")
        modal_step_4: snippet(group: "templates-PDP", name: "modal_step_4")
        modal_step_5: snippet(group: "templates-PDP", name: "modal_step_5")
        modal_now_in_3d: snippet(
          group: "templates-PDP"
          name: "modal_now_in_3d"
        )
        modal_open_3d: snippet(group: "templates-PDP", name: "modal_open_3d")
        gallery_lightbox_zoom: snippet(
          group: "templates-PDP"
          name: "gallery_lightbox_zoom"
        )
        open_3d_view: snippet(group: "templates-PDP", name: "open_3d_view")
        gallery_lightbox_indicator: snippet(
          group: "templates-PDP"
          name: "gallery_lightbox_indicator"
        )
        meta_title: snippet(group: "templates-PDP", name: "meta_title")
        meta_description: snippet(
          group: "templates-PDP"
          name: "meta_description"
        )
        rating_amount_text: snippet(
          group: "templates-PDP"
          name: "rating_amount_text"
        )
        ratings_headline: snippet(
          group: "templates-PDP"
          name: "ratings_headline"
        )
        size_chart_link: snippet(
          group: "templates-PDP"
          name: "size_chart_link"
        )
        templates_PDP_buy_box_buywrapper_a11y_decrease_amount_button: snippet(
          group: "templates-PDP"
          name: "templates_PDP_buy_box_buywrapper_a11y_decrease_amount_button"
        )
        templates_PDP_buy_box_buywrapper_a11y_amount_input: snippet(
          group: "templates-PDP"
          name: "templates_PDP_buy_box_buywrapper_a11y_amount_input"
        )
        templates_PDP_buy_box_buywrapper_a11y_increase_amount_button: snippet(
          group: "templates-PDP"
          name: "templates_PDP_buy_box_buywrapper_a11y_increase_amount_button"
        )
        templates_PDP_filterdrawer_customtailor_a11y_decrease_width_button: snippet(
          group: "templates-PDP"
          name: "templates_PDP_filterdrawer_customtailor_a11y_decrease_width_button"
        )
        templates_PDP_filterdrawer_customtailor_a11y_width_amount_input: snippet(
          group: "templates-PDP"
          name: "templates_PDP_filterdrawer_customtailor_a11y_width_amount_input"
        )
        templates_PDP_filterdrawer_customtailor_a11y_increase_width_button: snippet(
          group: "templates-PDP"
          name: "templates_PDP_filterdrawer_customtailor_a11y_increase_width_button"
        )
        templates_PDP_filterdrawer_customtailor_a11y_decrease_length_button: snippet(
          group: "templates-PDP"
          name: "templates_PDP_filterdrawer_customtailor_a11y_decrease_length_button"
        )
        templates_PDP_filterdrawer_customtailor_a11y_length_amount_input: snippet(
          group: "templates-PDP"
          name: "templates_PDP_filterdrawer_customtailor_a11y_length_amount_input"
        )
        templates_PDP_filterdrawer_customtailor_a11y_increase_length_button: snippet(
          group: "templates-PDP"
          name: "templates_PDP_filterdrawer_customtailor_a11y_increase_length_button"
        )
        sizeChart_international_size_table_title: snippet(
          group: "templates-PDP"
          name: "sizeChart_international_size_table_title"
        )
        sizeChart_product_size_table_title: snippet(
          group: "templates-PDP"
          name: "sizeChart_product_size_table_title"
        )
        sizeChart_clothing_size: snippet(
          group: "templates-PDP"
          name: "sizeChart_clothing_size"
        )
        sizeChart_button_label: snippet(
          group: "templates-PDP"
          name: "sizeChart_button_label"
        )
        sizeChart_arm_length_info: snippet(
          group: "templates-PDP"
          name: "sizeChart_arm_length_info"
        )
        sizeChart_back_length_info: snippet(
          group: "templates-PDP"
          name: "sizeChart_back_length_info"
        )
        sizeChart_chest_measurement_info: snippet(
          group: "templates-PDP"
          name: "sizeChart_chest_measurement_info"
        )
        sizeChart_hip_measurement_info: snippet(
          group: "templates-PDP"
          name: "sizeChart_hip_measurement_info"
        )
        sizeChart_inner_leg_length_info: snippet(
          group: "templates-PDP"
          name: "sizeChart_inner_leg_length_info"
        )
        sizeChart_total_length_info: snippet(
          group: "templates-PDP"
          name: "sizeChart_total_length_info"
        )
        sizeChart_waist_measurement_info: snippet(
          group: "templates-PDP"
          name: "sizeChart_waist_measurement_info"
        )
        sizeChart_waist_size_info: snippet(
          group: "templates-PDP"
          name: "sizeChart_waist_size_info"
        )
        sizeChart_measurement_infobox_title: snippet(
          group: "templates-PDP"
          name: "sizeChart_measurement_infobox_title"
        )
        sizeChart_measurement_infobox_text1: snippet(
          group: "templates-PDP"
          name: "sizeChart_measurement_infobox_text1"
        )
        sizeChart_measurement_infobox_text2: snippet(
          group: "templates-PDP"
          name: "sizeChart_measurement_infobox_text2"
        )
        sizeChart_measurement_tutorial_image_alt: snippet(
          group: "templates-PDP"
          name: "sizeChart_measurement_tutorial_image_alt"
        )
        sizeChart_scrollable_label: snippet(
          group: "templates-PDP"
          name: "sizeChart_scrollable_label"
        )
        to_measure_item_available: snippet(
          group: "templates-PDP"
          name: "to_measure_item_available"
        )
        redirect_to_product: snippet(
          group: "templates-PDP"
          name: "redirect_to_product"
        )
        per_squaremeter_text: snippet(
          group: "templates-PDP"
          name: "per_squaremeter_text"
        )

        pdp_successor_product: snippet(
          group: "templates-PDP"
          name: "pdp_successor_product"
        )
        pdp_alternative_product: snippet(
          group: "templates-PDP"
          name: "pdp_alternative_product"
        )
        pdp_alternative_products: snippet(
          group: "templates-PDP"
          name: "pdp_alternative_products"
        )
        manufacturer_info: snippet(
          group: "templates-PDP"
          name: "manufacturer_info"
        )
        manufacturer_name: snippet(
          group: "templates-PDP"
          name: "manufacturer_name"
        )
        manufacturer_address: snippet(
          group: "templates-PDP"
          name: "manufacturer_address"
        )
        manufacturer_mail: snippet(
          group: "templates-PDP"
          name: "manufacturer_mail"
        )
        gallery_lightbox_previous: snippet(
          group: "templates-PDP"
          name: "gallery_lightbox_previous"
        )
        gallery_lightbox_next: snippet(
          group: "templates-PDP"
          name: "gallery_lightbox_next"
        )
        thumbnail_bar_previous: snippet(
          group: "templates-PDP"
          name: "thumbnail_bar_previous"
        )
        thumbnail_bar_next: snippet(
          group: "templates-PDP"
          name: "thumbnail_bar_next"
        )
        highlight_product_action_btn_label: snippet(
          group: "templates-PDP"
          name: "highlight_product_action_btn_label"
        )
        BFSG_add_to_wishlist_button: snippet(
          group: "templates-PDP"
          name: "BFSG_add_to_wishlist_button"
        )
        BFSG_remove_from_wishlist_button: snippet(
          group: "templates-PDP"
          name: "BFSG_remove_from_wishlist_button"
        )
        BFSG_share_button: snippet(
          group: "templates-PDP"
          name: "BFSG_share_button"
        )
        to_filter_drawer_title: snippet(
          group: "templates-PDP"
          name: "to_filter_drawer_title"
        )
        BFSG_color_filter_option: snippet(
          group: "templates-PDP"
          name: "BFSG_color_filter_option"
        )
        BFSG_open_gallery_fullscreen: snippet(
          group: "templates-PDP"
          name: "BFSG_open_gallery_fullscreen"
        )
        BFSG_select_gallery_thumbnail: snippet(
          group: "templates-PDP"
          name: "BFSG_select_gallery_thumbnail"
        )
        BFSG_select_gallery_thumbnail_video: snippet(
          group: "templates-PDP"
          name: "BFSG_select_gallery_thumbnail_video"
        )
        BFSG_open_3d_view: snippet(
          group: "templates-PDP"
          name: "BFSG_open_3d_view"
        )
        BFSG_filterdrawer_close: snippet(
          group: "templates-PDP"
          name: "BFSG_filterdrawer_close"
        )
        BFSG_filterdrawer_apply: snippet(
          group: "templates-PDP"
          name: "BFSG_filterdrawer_apply"
        )
        BFSG_filterdrawer_option: snippet(
          group: "templates-PDP"
          name: "BFSG_filterdrawer_option"
        )
        BFSG_sizechart_button: snippet(
          group: "templates-PDP"
          name: "BFSG_sizechart_button"
        )
        BFSG_filterdrawer_customtailor_brink_filter: snippet(
          group: "templates-PDP"
          name: "BFSG_filterdrawer_customtailor_brink_filter"
        )
        BFSG_filterdrawer_customtailor_brinkwidth_filter: snippet(
          group: "templates-PDP"
          name: "BFSG_filterdrawer_customtailor_brinkwidth_filter"
        )
        BFSG_filterdrawer_customtailor_shape_filter: snippet(
          group: "templates-PDP"
          name: "BFSG_filterdrawer_customtailor_shape_filter"
        )
        BFSG_show_more_options: snippet(
          group: "templates-PDP"
          name: "BFSG_show_more_options"
        )
        BFSG_close_size_table_modal: snippet(
          group: "templates-PDP"
          name: "BFSG_close_size_table_modal"
        )
      }
    `)
  )
}
